import { FC } from 'react';
import { CommunityAvatar } from './CommunityAvatar';
import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { UserState } from '../user/UserState';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    addPostButton: {
        flexGrow: 1,
        margin: '10px 0',
        '--box-shadow': 'none',
        '& span': {
            marginRight: 'auto',
            color: 'var(--ion-color-step-900)',
            fontWeight: 'normal'
        }
    }
});

export type IPostOrCommentButtonProps = {
    onClick: () => void;
};

export const AddPostButton: FC<IPostOrCommentButtonProps> = ({ onClick }) => {
    const classes = useStyles();
    const userState = useInstance(UserState);

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
            <CommunityAvatar
                size={36}
                pictureUrl={userState.state.pictureUrl}
                firstName={userState.state.firstName}
                lastName={userState.state.lastName}
            />
            <IonButton
                className={classes.addPostButton}
                expand="block"
                color="light"
                data-id="add-post-button"
                onClick={onClick}
            >
                <span>
                    Post an update to your community
                </span>
            </IonButton>
        </div>
    );
};
